import script from "./PopupBundleInfoLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupBundleInfoLoading.vue?vue&type=script&setup=true&lang=ts"

import "./PopupBundleInfoLoading.vue?vue&type=style&index=0&id=22d6f1e2&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d6f1e2"]])

export default __exports__